import React, { Component } from 'react';
import * as AcceptTransferAction from '../actions/AcceptTransferAction';
import AcceptTransferStore from '../stores/AcceptTransferStore';
import * as $ from 'jquery';
import * as CookieService from '../CookieService';
import swal from 'sweetalert';
import SDIConstants from '../SDIConstants';
import { withTranslation } from 'react-i18next';
import * as MenuAction from '../actions/MenuAction';
let currentPagePath
class AcceptTransferComponent extends Component {
    constructor(props) {
        super(props);
        this.PageLoad = this.PageLoad.bind(this);
        this.PageLoadDataResponse = this.PageLoadDataResponse.bind(this);
        this.UpdateTransfer = this.UpdateTransfer.bind(this);
        this.UpdateTransferResponse = this.UpdateTransferResponse.bind(this);
        this.loadFavPageResponse = this.loadFavPageResponse.bind(this);
        this.updateFavPageResponse = this.updateFavPageResponse.bind(this);
        this.handleFavorite = this.handleFavorite.bind(this);
        this.checkItem = this.checkItem.bind(this);
        this.partitionClick = this.partitionClick.bind(this);
        this.bindcartData = this.bindcartData.bind(this);
        this.bindcartItemData = this.bindcartItemData.bind(this);

        this.state = {
            cartData: [],
            SelectedData: 0,
            totalCount: 0,
            submitEnabled: false,
            action: "",
            isFavorited: false,
            Page_ID: 0,
            distinctCartData: [],
            OrderCartData: [],
            selectAnyCheckbox: false,
            ItemIdsortType: false,
            SerialIdsortType: false
        };
    }

    componentDidMount() {

        //const SDIMenu = JSON.parse(localStorage.getItem("SDIMenu"));

        //const privilege = SDIMenu ? SDIMenu.find(item => item.ISA_IDENTIFIER_NAME === "Accept Transfer") : [];

        //if (!privilege) {
        //    this.props.history.push({
        //        pathname: "/HomePage"
        //    });
        //}

        // Update Session_PageName to window.location.pathname
        let actionName = "Accept Transfer";
        const SDIMenu = JSON.parse(localStorage.getItem("SDIMenu"));
        const privilege = SDIMenu.find(item => item.ISA_IDENTIFIER_NAME.toLowerCase() === actionName.toLowerCase());
        if (!privilege) {
            this.props.history.push({
                pathname: "/HomePage",
            });
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Insufficient privileges to view accept transfer"
            });
            
            return;
        }
        if (CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == null || CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == undefined ||
            CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == "" || CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == " " ||
            CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT").toUpperCase() != "0W0T") {
            if (CookieService.getLocalStorageValues("HideMobility") && CookieService.getLocalStorageValues("HideMobility").toUpperCase() == "TRUE") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "This page is exclusively for Truckstock. Please contact your admin/manager to set up the truck crib"
                });
                this.props.history.push({
                    pathname: `/homepage`
                });
            }
            else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "This page is exclusively for Truckstock. Please select truck crib from user profile to proceed."
            });
            this.props.history.push({
                pathname: `/profile`,
                state: { origin: 'Inventory' }
            });
            }
            return;
        }
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);

        // Get the currentPagePath from the props.location.pathname
        currentPagePath = this.props.location.pathname;

        // Create 'getFavPageBO' object with properties Session_USERID, pageURL, and Session_BUSUNIT
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        AcceptTransferAction.getCurrentFavPage(getFavPageBO);

        // Call PageLoad function
        this.PageLoad();

        // Add event listener 'pageload' with handler PageLoadDataResponse
        AcceptTransferStore.on('AcceptTransfer_PageLoad', this.PageLoadDataResponse);

        // Add event listener 'Action' with handler SubmitclickResponse
        AcceptTransferStore.on('AcceptTransfer_UpdateTransfer', this.UpdateTransferResponse);

        // Add event listener 'favpage' with handler loadFavPageResponse
        AcceptTransferStore.on('favpage', this.loadFavPageResponse);

        // Add event listener 'updateFavPage' with handler updateFavPageResponse
        AcceptTransferStore.on('updateFavPage', this.updateFavPageResponse);
    }

    componentWillUnmount() {
        AcceptTransferStore.removeListener('AcceptTransfer_PageLoad', this.PageLoadDataResponse);
        AcceptTransferStore.removeListener('AcceptTransfer_UpdateTransfer', this.UpdateTransferResponse);
        AcceptTransferStore.removeListener('favpage', this.loadFavPageResponse);
        AcceptTransferStore.removeListener('updateFavPage', this.updateFavPageResponse);
    }

    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(AcceptTransferStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };

    updateFavPageResponse = () => {
        if (AcceptTransferStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(AcceptTransferStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(AcceptTransferStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
    };

    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Accept Transfer",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            AcceptTransferAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            AcceptTransferAction.deleteFavPage(deleteFavPageBO)
        }
    };

    //WW-1331 Page load of Accept transfer
    PageLoad = () => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');

        // Form pageLoadBO with userId and businessUnit
        const pageLoadBO = {
            userId: CookieService.getLocalStorageValues("Session_UserID"),
            userBU: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };

        // Dispatch action pageLoad with pageLoadBO as parameter
        AcceptTransferAction.PageLoad(pageLoadBO);
    }

    //WW-1331 Page load response of Accept transfer
    PageLoadDataResponse = () => {
        // Initialize 'response' with the value from the 'pageload'
        let response = JSON.parse(AcceptTransferStore.PageLoadData);
        const { errorDt, AcceptTransferRes } = response;
        let selectedOrder = 1
        // Error handling
        if (errorDt[0].errorFlag.toUpperCase() === "TRUE") {
            swal({
                allowOutsideClick: true,
                closeOnClickOutside: true,
                text: 'Technical issue, please contact SDI help desk'
            });
            return;
        }

        let OrderCartData = AcceptTransferRes.filter(item => item.PARTITIONNUM === parseInt(selectedOrder));

        let maxPartitionNum = Math.max(
            ...AcceptTransferRes
                .map(item => item.PARTITIONNUM)
        );

        const uniqueOrderData = new Map();

        AcceptTransferRes.forEach((item) => {
            if (!uniqueOrderData.has(item.ORDER_NO)) {
                uniqueOrderData.set(item.ORDER_NO, item);
            }
        })

        const distinctCartData = Array.from(uniqueOrderData.values());

        this.setState({
            cartData: AcceptTransferRes,
            SelectedData: selectedOrder,
            totalCount: maxPartitionNum,
            distinctCartData: distinctCartData,
            OrderCartData: OrderCartData
        });

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    };

    //WW-1331 When click the checkbox
    checkItem = (index, type, e) => {
        // Create a copy of the cartData array
        let updatedCartData = this.state.OrderCartData;
        let distinctCartData = this.state.distinctCartData;

        if (type === 'All') {
            // If type is "all", set 'checked' property to true for all items in this.state.cartData
            updatedCartData = updatedCartData.map(item => ({ ...item, checked: e.target.checked }));

            distinctCartData[index] = { ...distinctCartData[index], checked: e.target.checked };

            const areChecked = updatedCartData.some(item => item.checked == true);

            this.setState({ OrderCartData: updatedCartData, selectAnyCheckbox: areChecked, distinctCartData: distinctCartData });
        } else {

            // If type is empty, toggle 'checked' property of the item at this.state.cartData[index]
            updatedCartData[index] = { ...updatedCartData[index], checked: e.target.checked };

            // Check if all items are checked
            const areChecked = updatedCartData.some(item => item.checked == true);

            const allChecked = updatedCartData.every(item => item.checked == true);

            if (allChecked) {
                distinctCartData[(this.state.SelectedData - 1)] = { ...distinctCartData[(this.state.SelectedData - 1)], checked: true };
            }
            else {
                distinctCartData[(this.state.SelectedData - 1)] = { ...distinctCartData[(this.state.SelectedData - 1)], checked: false };
            }

            // Update the state accordingly
            this.setState({
                OrderCartData: updatedCartData,
                selectAnyCheckbox: areChecked,
                distinctCartData: distinctCartData
            });
        }
    }

    //WW-1331 When click the page number icon
    partitionClick = (type) => {
        let SelectedData = this.state.SelectedData;

        if (type === 'increment') {
            // Increment SelectedData by 1 if type is "increment"
            SelectedData += 1;
        } else if (type === 'decrement') {
            // Decrement SelectedData by 1 if type is "decrement"
            SelectedData = SelectedData - 1;
        }

        // Filter pageLoad data where SelectedData equals to partitionNum and assign to cartData
        let OrderCartData = this.state.cartData.filter(item => item.PARTITIONNUM === SelectedData);
        let distinctCartData = this.state.distinctCartData.map(item => ({
            ...item,
            checked: false // Set checked property to false for all items
        }));

        // Update state with new SelectedData and cartData
        this.setState({
            distinctCartData,
            SelectedData,
            OrderCartData,
            selectAnyCheckbox: false
        });
    }

    //WW-1331 When click Approve or Decline buttons
    UpdateTransfer = (action) => {
        // User initiates submit or decline action
        const { OrderCartData } = this.state;

        // Create object to store input data for action
        let AcceptTransferInObj = {
            userId: CookieService.getLocalStorageValues("Session_UserID") ? CookieService.getLocalStorageValues("Session_UserID") : "",
            userBU: CookieService.getLocalStorageValues("Session_BUSUNIT") ? CookieService.getLocalStorageValues("Session_BUSUNIT") : "",
            location: CookieService.getLocalStorageValues("Session_WO_STATE") ? CookieService.getLocalStorageValues("Session_WO_STATE") : CookieService.getLocalStorageValues("Session_STATE"),
            orderNo: OrderCartData[0].ORDER_NO,
            selectedItems: OrderCartData.filter(item => item.checked).map(item => item.INV_ITEM_ID) // Assuming only IDs needed; transform according to your data format
        };

        // Assign appropriate status type and method to call depending on action
        if (action === 'accept') {
            AcceptTransferInObj.statusType = 'accept'; // If action is submit, set "A" in AcceptTransferInObj.StatusType

        } else if (action === 'decline') {
            AcceptTransferInObj.statusType = 'decline'; // If action is decline, set "R" in AcceptTransferInObj.StatusType
        }

        this.setState({ action: action })
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');

        // Call ButtonActionClick with AcceptTransferInObj
        AcceptTransferAction.UpdateTransfer(AcceptTransferInObj);
    }

    //WW-1331 Response of Approve or Decline buttons
    UpdateTransferResponse = () => {
        // Initialize 'response' with the value from the 'pageload'
        let response = JSON.parse(AcceptTransferStore.updateData);
        const { errorDt, AcceptTransferRes } = response;
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

        // Error handling
        if (errorDt[0].errorFlag.toUpperCase() === "TRUE" || AcceptTransferRes == []) {
            swal({
                allowOutsideClick: true,
                closeOnClickOutside: true,
                text: 'Technical issue, please contact SDI help desk'
            });
            return;
        }
        if (response.UpdateStatusDt && response.UpdateStatusDt[0].status.substring(0, 3).toLowerCase() === "suc") {
            if (this.state.action == 'accept') {
                $('#SuccessPopup').modal('show');
            }
            else {
                $('#DeclinePopup').modal('show');
            }
        }
        this.PageLoad()
    };

    //WW-1331 To close the popups
    PopupOkClick = () => {
        $('#SuccessPopup').modal('hide');
        $('#DeclinePopup').modal('hide');
        this.setState({ selectAnyCheckbox: false })
    }

    //WW-1331 To sort the items
    handleSort = (event) => {
        const columns = document.querySelectorAll('.table-sort .sort-icon');
        const clickedColumn = event.currentTarget.querySelector('.sort-icon');
        columns.forEach(column => {
            if (column !== clickedColumn) {
                column.classList.remove('desc');
                column.classList.add('asc');
            }
        });

        let sortValue = "";
        let sortCoulumn = event.target.id;
        if (clickedColumn.classList.contains('asc')) {
            clickedColumn.classList.remove('asc');
            clickedColumn.classList.add('desc');
            sortValue = 'DESC';
        } else {
            clickedColumn.classList.remove('desc');
            clickedColumn.classList.add('asc');
            sortValue = 'ASC';
        }

        this.sort(sortCoulumn, sortValue);
    }

    sort = (Column, Type) => {
        const Arr = [...this.state.OrderCartData]; // create a copy of the state array
        const size = Arr.length;

        // Compare function for ascending order
        const compareAsc = (a, b) => (a[Column] > b[Column]) ? 1 : ((a[Column] < b[Column]) ? -1 : 0);
        // Compare function for descending order
        const compareDesc = (a, b) => (a[Column] < b[Column]) ? 1 : ((a[Column] > b[Column]) ? -1 : 0);

        // Use the built-in `sort` method with the appropriate compare function
        const sortedArr = Arr.sort(Type === "ASC" ? compareAsc : compareDesc);

        this.setState({ OrderCartData: sortedArr });

        return sortedArr; // this line is not actually required for React components
    }

    //WW-1331 To bind the order level data
    bindcartData = () => {
        let itemData = this.state.distinctCartData.filter(item => item.PARTITIONNUM === parseInt(this.state.SelectedData));
        let sortshow = this.state.OrderCartData.length;
        return itemData.map((value, index) => {

            return (
                <>
                    <p className="font-14 app-enhancements-main-content mb-2 text-wrap">
                        Order No:
                        <span className="app-enhancements-sub-content ml-3">{value.ORDER_NO}</span>
                    </p>

                    <div className="row d-flex p-0 m-0 align-items-center accept-transfer-employee-section mb-4">
                        <div className="col-xl-3 col-lg-4 col-md-12 p-3">
                            <div className="mb-2">
                                <p className="font-14 app-enhancements-main-content mb-0 text-wrap">
                                    Employee from :
                                    <span className="app-enhancements-sub-content ml-3">
                                        {value.EMPFROMNAME}
                                    </span>
                                </p>
                            </div>
                            <div className="mb-2">
                                <p className="font-14 app-enhancements-main-content mb-0 text-wrap">
                                    Location from :
                                    <span className="app-enhancements-sub-content ml-3">{value.STORAGE_AREA}-{value.TRUCKDESC}</span>
                                </p>
                            </div>
                            <div className="">
                                <p className="font-14 app-enhancements-main-content mb-0 text-wrap">
                                    Market :
                                    <span className="app-enhancements-sub-content ml-3">{value.TRANSFERRED_EMPLOYEE_REGION}</span>
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-1 col-md-12 justify-content-center d-flex transform-employee-info">
                            <img src="images/accept-transfer-icon.svg" alt="" />
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-12 p-3">
                            <div className="mb-2">
                                <p className="font-14 app-enhancements-main-content mb-0 text-wrap">
                                    Employee to :
                                    <span className="app-enhancements-sub-content ml-3">
                                        {value.EMPTONAME}
                                    </span>
                                </p>
                            </div>
                            <div className="mb-2">
                                <p className="font-14 app-enhancements-main-content mb-0 text-wrap">
                                    Location from :
                                    <span className="app-enhancements-sub-content ml-3">{value.TO_STORAGE_AREA}-{value.TOTRUCKDESC}</span>
                                </p>
                            </div>
                            <div className="">
                                <p className="font-14 app-enhancements-main-content mb-0 text-wrap">
                                    Market :
                                    <span className="app-enhancements-sub-content ml-3">{value.LOGGED_IN_USER_REGION}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* Employee Info end here */}

                    {/* table start here */}
                    <h6 className="bin-transfer-table-title">Transfer List</h6>
                    <div className="table-responsive mt-2 mb-3 pt-2 bin-transfer-table-container mb-5 pb-5">
                        <table className="table split-delv-table ZEUS_Grid FOM-grid mobileresponsive-grid">
                            <thead>
                                <tr>

                                    <th className="text-center">
                                        <input
                                            className="form-check-input position-unset mx- m-0"
                                            type="checkbox"
                                            checked={value.checked}
                                            id="checkbox-2"
                                            onChange={(e) => this.checkItem((this.state.SelectedData - 1), "All", e)}
                                        />
                                    </th>

                                    <th className="font-14">
                                        Item ID
                                            <span className="table-sort" onClick={(e) => { this.handleSort(e) }}>
                                            {sortshow > 1 ? (<img src="Images/table-sort-icon-bottom.svg" id="INV_ITEM_ID" className='sort-icon asc' alt="sort-up" />) : null}
                                        </span>
                                    </th>
                                    <th>Description</th>
                                    <th>
                                        Serial ID
                                        <span className="table-sort" onClick={(e) => { this.handleSort(e) }}>
                                            {sortshow > 1 ? (<img src="Images/table-sort-icon-bottom.svg" id="SERIAL_ID" className='sort-icon asc' alt="sort-up" />) : null}
                                        </span>
                                    </th>
                                    <th className="text-end">Quantity</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.bindcartItemData()}
                            </tbody>
                        </table>
                        <div className="d-flex justify-content-end pb-3 btn-container">
                            <button className={`btn btn-primary custom-btn-decline primary-btn float-left px-4 mb-2 mr-3 ${this.state.selectAnyCheckbox ? null : "disabled"}`} onClick={(e) => this.UpdateTransfer("decline")} >
                                Decline
                            </button>
                            <button className={`btn btn-primary custom-btn-approve float-left px-4 mr-2 mb-2 ${this.state.selectAnyCheckbox ? null : "disabled"}`} onClick={(e) => this.UpdateTransfer("accept")}>
                                Approve
                            </button>
                        </div>
                    </div>
                    {/* table end here */}
                </>
            )
        })
    }

    //WW-1331 To bind the table data
    bindcartItemData = () => {

        return this.state.OrderCartData.map((value, index) => {
            return (
                <>
                    {/*row starts here*/}
                    <tr>
                        <td className="text-center ">
                            <input
                                className="form-check-input position-unset mx- m-0"
                                type="checkbox"
                                defaultValue=""
                                id="checkbox-2"
                                checked={value.checked}
                                onChange={(e) => this.checkItem(index, "Line", e)}
                            />
                        </td>
                        <td>{value.INV_ITEM_ID}</td>
                        <td>{value.DESCR254}</td>
                        <td>{value.SERIAL_ID}</td>
                        <td className="text-end">{value.QTY}</td>
                    </tr>
                    {/*row ends here*/}
                </>
            )
        })
    }

    render() {
        const { t } = this.props;

        return (
            <React.Fragment>
                <div className="container-fluid custom-barcode-label-page" style={{ marginTop: "132px" }}>
                    {/*Page Heading starts here*/}
                    <div className="row p-1">
                        <div className="col-md-12 mt-3 pb-1 page-heading p-0">
                            <h5 className="page-title">Accept Transfer</h5>
                            <div className="fav-item-maintenance-icon mt-1">
                                <input type="checkbox" id="checkbox-1" className="checknow" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                <label htmlFor="checkbox-1">
                                    <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                        <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                            <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                            <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                            <g className="grp7" opacity={0} transform="translate(7 6)">
                                                <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                            </g>
                                            <g className="grp6" opacity={0} transform="translate(0 28)">
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                            </g>
                                            <g className="grp3" opacity={0} transform="translate(52 28)">
                                                <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                            </g>
                                            <g className="grp2" opacity={0} transform="translate(44 6)">
                                                <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp5" opacity={0} transform="translate(14 50)">
                                                <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp4" opacity={0} transform="translate(35 50)">
                                                <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp1" opacity={0} transform="translate(24)">
                                                <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                            </g>
                                        </g>
                                    </svg>
                                </label>
                            </div>
                        </div>
                    </div>
                    {/*Page Heading ends here*/}
                    {/* Body contents here */}
                    <div className="col-md-12 pt-3 p-2 accept-transfer-container">
                        {/* Employee Info start here */}
                        {/* Pagination Section Start here */}
                        {this.state.distinctCartData && this.state.distinctCartData.length > 0 ? < div className="d-flex justify-content-between align-items-center mb-2 custom-pagination-section">
                            <h6 className="bin-transfer-table-title m-0">Employee Info</h6>
                            <nav className="d-flex justify-content-center">
                                <ul className="custom-pagination mb-0 align-items-center ">
                                    <p className="mb-0 mr-3 font-14">
                                        <span>{this.state.SelectedData}</span> of <span>{this.state.totalCount}</span>
                                    </p>
                                    <p className="page-item mr-2">
                                        <span onClick={(e) => this.partitionClick("decrement")}
                                            className={`page-link cust-pagination-arrow d-flex align-items-center border-0 ${this.state.SelectedData == 1 ? "inactive" : null}`}  >
                                            <img
                                                src="images/pagination-left-icon.svg"
                                                alt="left-pagination-arrow"
                                                className="right-pagination-arrow"
                                            />
                                        </span>
                                    </p>
                                    <p className="page-item ms-2">
                                        <span onClick={(e) => this.partitionClick("increment")}
                                            className={`page-link cust-pagination-arrow border-0 d-flex align-items-center justify-content-center ${this.state.SelectedData == this.state.totalCount ? "inactive" : null}`}
                                            href="#"
                                        >
                                            <img
                                                src="images/pagination-right-icon.svg"
                                                alt="right-pagination-arrow"
                                                className="left-pagination-arrow"
                                            />
                                        </span>
                                    </p>
                                </ul>
                            </nav>
                        </div>
                            :
                            <div className=" pt-2">
                                <div className="col-md-12 p-2 p-0 accept-transfer-container">
                                    <div className="no-record-found-section">
                                        <img src="Images/no-record-found.png" alt="select-file-to-view-img" className="no-record-found" />
                                        <label className="font-14 mt-4 text-label-color custom-select-records">You have no incoming stock transfers awaiting your acceptance.</label>
                                    </div>
                                </div>
                            </div>}
                        {this.state.distinctCartData ? this.bindcartData() : null}
                    </div>
                </div>

                {/*Success Popup Modal Starts here*/}
                <div className="modal fade success-customer" id="SuccessPopup" tabIndex={-1} role="dialog" data-backdrop="static" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered custom-success-width" role="document">
                        <div className="modal-content py-2">
                            {/*Success Starts here*/}
                            <div className="modal-body pb-2">
                                <div className="row">
                                    <div className="col-12 col-sm-12  col-md-12 col-lg-12 text-center">
                                        <img className="mb-3" src="images/tick.svg" alt="tick" />
                                        <p className="mb-1 font-14 font-regular color-light-black">Your items has been transferred successfully</p>
                                    </div>
                                </div>
                            </div>
                            {/*Success end here*/}
                            {/*button*/}
                            <div className="modal-footer border-0 d-flex justify-content-center pt-1">
                                <button className="btn btn-custom-primary font-15 font-medium mr-2 mb-2 px-4 py-2" onClick={() => { this.PopupOkClick() }}>OK</button>
                            </div>
                            {/*button*/}
                        </div>
                    </div>
                </div>
                {/*Success Popup Modal Ends here*/}

                {/*Failure Popup Modal Starts here*/}
                <div className="modal fade success-customer" id="DeclinePopup" tabIndex={-1} role="dialog" data-backdrop="static" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered custom-success-width" role="document">
                        <div className="modal-content py-2">
                            {/*Success Starts here*/}
                            <div className="modal-body pb-2">
                                <div className="row">
                                    <div className="col-12 col-sm-12  col-md-12 col-lg-12 text-center">
                                        <img className="mb-3" src="images/cross-accept.svg" alt="tick" />
                                        <p className="mb-1 font-14 font-regular color-light-black">Your items has been declined successfully</p>
                                    </div>
                                </div>
                            </div>
                            {/*Success end here*/}
                            {/*button*/}
                            <div className="modal-footer border-0 d-flex justify-content-center pt-1">
                                <button className="btn btn-custom-primary font-15 font-medium mr-2 mb-2 px-4 py-2" onClick={() => { this.PopupOkClick() }}>OK</button>
                            </div>
                            {/*button*/}
                        </div>
                    </div>
                </div>
                {/*Failure Popup Modal Ends here*/}

            </React.Fragment>

        );
    }
}

export default withTranslation()(AcceptTransferComponent);